import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCursorAgent = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21.2643 6.20727L12.4571 1.12249C12.1743 0.95917 11.8253 0.95917 11.5425 1.12249L2.73572 6.20727C2.49798 6.34454 2.3512 6.5984 2.3512 6.87336V17.1268C2.3512 17.4018 2.49798 17.6557 2.73572 17.7929L11.5429 22.8777C11.8257 23.041 12.1747 23.041 12.4575 22.8777L21.2647 17.7929C21.5024 17.6557 21.6492 17.4018 21.6492 17.1268V6.87336C21.6492 6.5984 21.5024 6.34454 21.2647 6.20727H21.2643ZM20.7111 7.28434L12.209 22.0103C12.1515 22.1095 11.9998 22.069 11.9998 21.954V12.3116C11.9998 12.119 11.8968 11.9408 11.7298 11.844L3.37948 7.02303C3.28025 6.96556 3.32077 6.81382 3.43571 6.81382H20.4398C20.6813 6.81382 20.8322 7.07554 20.7115 7.28475H20.7111V7.28434Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgCursorAgent);
export { ForwardRef as ReactComponent };
